import React from 'react';
import FadeUp from '../ui/FadeUp';
import SafeIcon from '@/common/SafeIcon';

export default function Services() {
  const services = [
    { icon: 'Box', name: 'Furniture Removal', desc: 'Sofas, tables, chairs, dressers — we\'ll haul any furniture regardless of size.' },
    { icon: 'Square', name: 'Mattress Removal', desc: 'Old mattresses removed quickly and responsibly. No hassle disposal.' },
    { icon: 'Cpu', name: 'Appliance Removal', desc: 'Fridges, washers, dryers, microwaves — we handle all appliances.' },
    { icon: 'Home', name: 'Garage Clean-outs', desc: 'Transform your cluttered garage back into a usable space.' },
    { icon: 'Database', name: 'Shed Clean-outs', desc: 'Old tools, broken equipment, decades of clutter — all cleared out.' },
    { icon: 'Feather', name: 'Yard Debris Removal', desc: 'Branches, brush, leaves, and landscaping waste hauled away fast.' },
    { icon: 'Package', name: 'Moving Clean-outs', desc: 'Moving in or out? We\'ll clear what you don\'t want to take with you.' },
    { icon: 'Map', name: 'Estate Clean-outs', desc: 'Respectful, thorough clean-outs for estates of any size.' },
    { icon: 'Trash2', name: 'Bulk Item Pickup', desc: 'One item or a truckload — general trash and bulk items hauled away.' },
  ];

  return (
    <section id="services" className="bg-dark-2 section-padding border-t border-dark-4">
      <FadeUp className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-16">
        <div>
          <div className="font-condensed text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4">What We Remove</div>
          <h2 className="font-condensed font-black text-[clamp(36px,4vw,56px)] uppercase leading-none text-white">Our Services</h2>
        </div>
        <p className="text-text-muted text-[18px] leading-relaxed max-w-[560px] font-medium">
          From single items to full property cleanouts — if you want it gone, we'll make it happen.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0.5 bg-dark-4 border border-dark-4">
        {services.map((service, i) => (
          <FadeUp key={i} delay={i * 0.05} className="bg-dark-3 p-8 relative overflow-hidden">
            <SafeIcon name={service.icon} className="text-[32px] text-gold mb-6" />
            <div className="font-condensed font-bold text-xl uppercase tracking-wide mb-3 text-white">{service.name}</div>
            <div className="text-[15px] text-text-muted leading-relaxed font-medium">{service.desc}</div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}